import { fetch } from '@mindbaz/app-manager';

export const isAdminMotherCompagnies = async () => {
  return fetch({
    method: 'GET',
    url: `${import.meta.env.VITE_API_CORE}features/canAdmin`,
  }).then((result: any) => {
    return result.data.data;
  });
};
